module.exports = __webpack_public_path__ + "static/media/link.547cadd2.svg";